import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchRecipes, clearMessage } from '../../../redux/slices/customer/recipeSlice';
import Layout from '../Layout';
import { Link } from 'react-router-dom';
import '../../../global.css';
import Back from '../../../components/common/Back';
import arrowRight from '../../../images/icon-double-arrow-right.svg';
import arrowLeft from '../../../images/icon-double-arrow-left.svg';
import { useParams } from 'react-router-dom';

const Recipes = () => {
  const dispatch = useDispatch();
  const [searchTerm, setsearchTerm] = useState('');
  const { category } = useParams();
  const [activeTab, setActiveTab] = useState('All');
  
  const { recipes, currentPage, totalPages, isLoading, errorMessage } = useSelector(
    (state) => state.recipes
  );
  
  const mealTypes = useSelector((state) => state.app_options?.meal_types_min);

  useEffect(() => {
    dispatch(clearMessage());
  }, []); 

  useEffect(() => {
    dispatch(fetchRecipes({"page":1, "searchTerm":searchTerm}));
  }, [dispatch]);

   useEffect(() => {
    dispatch(fetchRecipes({"page":1, "searchTerm":searchTerm}));
  }, [searchTerm]);

  const handlePagination = (page) => {
    dispatch(fetchRecipes({"page":page, "searchTerm":''}));
  };

  const handleSearch = (searchTerm) => {
    var search_recipe = document.getElementById('search_recipe').value;
    setsearchTerm(search_recipe);
  };

  const handleCategoryClicked = (activeTab) => {
    setActiveTab(activeTab); 
    dispatch(fetchRecipes({"page":1, "searchTerm":searchTerm, "activeTab":activeTab}));
  };

  return (
    <Layout>
      <main className="main page-add-meal">
        <header>
          <div className="main-head flex pb-0">
            <h1 className="greet-user-text">Recipes</h1>
            <div className="ms-auto">
              <Back />
            </div>
          </div>
        </header>

        <div className="main-content flex justify-between flex-col-rev-mob">
          <div style={{ width: '100%' }}>
            <div className="meals-container meals-added pt-0"></div>
            <div className="col-12">
              <div className="position-relative wrap-meal-search mb-3 search-input">
                <input
                  type="text"
                  className="page-add-meal search-input form-group input edgeInput"
                  id="search_recipe"
                  placeholder="Search"
                  value={searchTerm}
                  onChange={()=>handleSearch()}
                />
              </div>
            </div>

            <div className="tags_container">
                  <Link className={activeTab == 'All' ? 'active-category' : ''} onClick={() => handleCategoryClicked('All')} >All</Link>
                  {mealTypes && mealTypes?.map((type) => (
                    <Link className={activeTab == type.id ? 'active-category' : ''} onClick={() => handleCategoryClicked(type.id)}>{type.title}</Link>
                  ))}
                  <Link className={activeTab == 'favourite' ? 'active-category' : ''} onClick={() => handleCategoryClicked('favourite')}>My Favourites</Link>
            </div>

            {/* Render recipes here */}
            <div className="col-12 mt-4">
              <div className="card-recipes">
                <div className="row">
                  {isLoading ? (
                    <p>Loading...</p>
                  ) : errorMessage ? (
                    <p>Error: {errorMessage}</p>
                  ) : (
                    recipes && recipes.map((recipe) => (
                      <div key={recipe.id} className="col-md-6 mt-4">
                        <div className="row">
                          <div className="col-md-4">
                            <img
                              src={recipe.meal_picture_full_url}
                              alt={recipe.meal_name}
                              className="img-fluid rounded"
                            />
                          </div>
                          <div className="col-md">
                            <h4>{recipe.meal_name}</h4>
                            <p>{recipe.recipe_calories} kcal</p>
                             <Link to={`/recipe-detail/${category}/${recipe.id}`} className="btn-save-meal view_recipe_btn recipe">
                                View
                            </Link>
                          </div>
                        </div>
                      </div>
                    ))
                  )}
                </div>
              </div>
            </div>

            <div className="col-12 text-center mt-4">
              <div className="pagination-wrap">
                <ul>
                  {currentPage > 1 && (
                    <li>
                      <a onClick={() => handlePagination(currentPage - 1)}>
                        <img
                          src={arrowLeft}
                          alt="Previous"
                        />
                      </a>
                    </li>
                  )}
                  <li>
                    <a className="active">{currentPage}</a>
                  </li>
                  {currentPage < totalPages && (
                    <li>
                      <a onClick={() => handlePagination(currentPage + 1)}>
                        <img
                          src={arrowRight}
                          alt="Next"
                        />
                      </a>
                    </li>
                  )}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </main>
    </Layout>
  );
};

export default Recipes;